"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const HTMLDialogElementCompatibility_1 = require("@/client/components/HTMLDialogElementCompatibility");
const raw_settings = __importStar(require("@/genfiles/settings.json"));
const vueRoot_1 = require("@/client/components/vueRoot");
const PreferencesManager_1 = require("../utils/PreferencesManager");
const dialog_polyfill_1 = __importDefault(require("dialog-polyfill"));
function browser() {
    const ua = navigator.userAgent;
    let match = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(match[1])) {
        const temp = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (temp[1] || '');
    }
    if (match[1] === 'Chrome') {
        const temp = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (temp !== null)
            return temp.slice(1).join(' ').replace('OPR', 'Opera');
    }
    match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, '-?'];
    const temp = ua.match(/version\/(\d+)/i);
    if (temp !== null)
        match.splice(1, 1, temp[1]);
    return match.join(' ');
}
exports.default = (0, vue_1.defineComponent)({
    name: 'BugReportDialog',
    data() {
        return {
            message: '',
            showCopied: false,
        };
    },
    computed: {
        typedRefs() {
            return this.$refs;
        },
    },
    methods: {
        show() {
            (0, HTMLDialogElementCompatibility_1.showModal)(this.typedRefs.dialog);
        },
        copyTextArea() {
            this.typedRefs.textarea.select();
            navigator.clipboard.writeText(this.typedRefs.textarea.value);
            this.showCopied = true;
        },
        url(playerView) {
            const url = new URL(window.location.href);
            const spectatorId = playerView?.game?.spectatorId;
            if (spectatorId && url.pathname === '/player' && url.searchParams.has('id')) {
                url.searchParams.set('id', spectatorId);
                url.pathname = '/spectator';
            }
            return url;
        },
        setMessage() {
            const playerView = (0, vueRoot_1.vueRoot)(this).playerView;
            const content = {
                url: this.url(playerView),
            };
            if (playerView !== undefined) {
                Object.assign(content, {
                    color: playerView.thisPlayer.color,
                    expansions: Object.entries(playerView.game.gameOptions.expansions)
                        .filter(([_k, v]) => v === true)
                        .map(([k, _v]) => k)
                        .join(', '),
                    step: playerView.game.step,
                });
            }
            Object.assign(content, {
                version: raw_settings.head,
                builtAt: raw_settings.builtAt,
                browser: browser(),
                language: (0, PreferencesManager_1.getPreferences)().lang,
                experimental_ui: (0, PreferencesManager_1.getPreferences)().experimental_ui,
            });
            this.message = JSON.stringify(content, null, 2);
        },
    },
    mounted() {
        if (!(0, HTMLDialogElementCompatibility_1.windowHasHTMLDialogElement)())
            dialog_polyfill_1.default.registerDialog(this.typedRefs.dialog);
        this.setMessage();
    },
});
